<template>
  <div class="d-flex flex-row flex-wrap">
    <div
      v-for="(item, index) in list"
      :key="index"
      class="d-inline-block"
      style="padding-right: 0.5rem; max-width: 400px"
    >
      <Multiselect
        v-if="!item.type"
        v-model="selected[index]"
        :custom-label-fnc="item.customLabel ? item.customLabel : null"
        :options="item.options"
        :multiple="item.multiple"
        :placeholder="item.placeholder"
        :track-by="item.trackBy ? item.trackBy : 'value'"
        :label="item.label ? item.label : 'name'"
        :translate="
          typeof item.translate != 'undefined' ? item.translate : true
        "
        selectLabel="select"
        deselectLabel="deselect"
        selectedLabel="selected"
        :close-on-select="item.close_on_select"
        :hide-selected="item.hide_select"
        @search-change="
          item.remote ? searchChange(item, index, ...arguments) : null
        "
        :loading="item.remote ? isLoading : false"
      ></Multiselect>

      <DateRangePicker
        :ref="`date${index}`"
        v-model="date"
        class="custom-picker"
        v-if="item.type == 'date'"
        @update="updateDate"
        :locale-data="
          typeof item.locale !== 'undefined' ? item.locale : ui.locale
        "
        :opens="item.opens ? item.opens : ui.opens"
        :singleDatePicker="item.singleDatePicker ? true : false"
        :timePicker="
          typeof item.timePicker !== 'undefined' ? item.timePicker : true
        "
        :timePicker24Hour="true"
        :timePickerSeconds="
          typeof item.timePickerSeconds !== 'undefined'
            ? item.timePickerSeconds
            : false
        "
        :timePickerIncrement="
          typeof item.timePickerIncrement !== 'undefined'
            ? item.timePickerIncrement
            : 5
        "
        :ranges="typeof item.ranges !== 'undefined' ? item.ranges : ui.ranges"
        :show-dropdowns="
          typeof item.showDropdowns !== 'undefined' ? item.showDropdowns : false
        "
        :id="index"
        :reset="true"
      ></DateRangePicker>
    </div>
    <div class="d-inline-block">
      <b-button
        @click="$emit('click')"
        class="refresh mr-2"
        variant="light"
        size="sm"
        :title="$t('Filter')"
      >
        <i class="la la-filter" style="margin: 0; padding: 0" />
      </b-button>
      <b-button
        @click="clearFilters"
        class="refresh"
        variant="light"
        size="sm"
        v-if="isSomethingSelected"
        :title="$t('Clear')"
      >
        <i class="la la-times-circle" style="margin: 0; padding: 0" />
      </b-button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Multiselect from "./multiselect-filters";
import DateRangePicker from "./calendar-range/DateRangePicker";
import timeFormat from "../shared/timeFormat";
import { CACHE_INVALIDATE } from "@/store/mutation-types";

export default {
  name: "tableFilters",
  props: ["value"],
  components: {
    Multiselect,
    DateRangePicker,
  },
  data() {
    return {
      list: [],
      selectedMax: 0,
      selected: [],
      dataChanged: false,
      isLoading: false,
      date: {
        startDate: null,
        endDate: null,
      },
      ui: {
        opens: "center", //which way the picker opens, default "center", can be "left"/"right"
        locale: {
          format: timeFormat.datePickerLong, //format of the dates displayed
          firstDay: 1, //ISO first day of week - see moment documenations for details
          showWeekNumbers: true, //show week numbers on each row of the calendar
        },
        ranges: {
          Today: [moment().startOf("day"), moment().endOf("day")],
          Yesterday: [
            moment().subtract(1, "days").startOf("day"),
            moment().subtract(1, "days").endOf("day"),
          ],
          Tomorrow: [
            moment().add(1, "days").startOf("day"),
            moment().add(1, "days").endOf("day"),
          ],
          "This week": [moment().startOf("isoWeek"), moment().endOf("isoWeek")],
          "Next week": [
            moment().add(1, "weeks").startOf("isoWeek"),
            moment().add(1, "weeks").endOf("isoWeek"),
          ],
        },
      },
    };
  },
  beforeMount() {
    this.oldSelected = [];
    this.loadFiltersData();
  },
  computed: {
    isSomethingSelected() {
      let ret = false;

      if (!(this.selected.join().replace(/,/g, "").length === 0)) {
        ret = true;
      }

      if (this.dataChanged) {
        ret = true;
      }

      return ret;
    },
  },
  methods: {
    searchChange(item, index, query) {
      const self = this;
      console.log("searchChange[item, query]", item, query);

      if (query && query.length > 3 && item.remote && item.store) {
        self.isLoading = true;
        self.$store
          .dispatch("cache/fetch", {
            key: item.store,
            filterData: {
              likeFields: item.likeFields,
              likeValues: new Array(item.likeFields.length).fill(query),
            },
            force: true,
          })
          .then((rows) => {
            self.list[index].options = rows;
            self.list[index].originalOptions = rows;
          })
          .catch((e) => e)
          .finally(() => {
            self.isLoading = false;
          });
      }
    },
    loadFiltersData() {
      var self = this;
      this.list = this.value;

      for (let i = 0; i < this.list.length; i++) {
        if (
          typeof this.list[i].type == "undefined" ||
          this.list[i].type != "date"
        ) {
          // no op
          if (typeof self.list[i].selected !== "undefined") {
            const s = JSON.parse(JSON.stringify(self.list[i].selected));
            self.selected.push(s);
            self.oldSelected.push("[]");
          }
        } else {
          if (
            this.list[i].selected.startDate != null &&
            this.list[i].selected.endDate != null
          ) {
            this.date.startDate = this.list[i].selected.startDate;
            this.date.endDate = this.list[i].selected.endDate;
            this.dataChanged = true;
          }
        }
      }
      this.selectedMax = this.selected.length;
      const promises = [];
      const indexes = [];
      this.value.forEach((item, index) => {
        if (item.store) {
          if (!item.dateField && !item.remote) {
            promises.push(
              self.$store.dispatch("cache/fetch", item.store).catch((e) => e)
            );
          } else if (!item.remote) {
            promises.push(
              self.$store
                .dispatch("cache/fetch", {
                  key: item.store,
                  dateData: {
                    dateField: item.dateField,
                    dateStart: self.date.startDate,
                    dateEnd: self.date.endDate,
                  },
                })
                .catch((e) => e)
            );
          }

          indexes.push(index);
        }
      });

      Promise.all(promises).then(function (values) {
        values.forEach((rows, i) => {
          if (rows && Array.isArray(rows)) {
            self.list[indexes[i]].options = rows;
            self.list[indexes[i]].originalOptions = rows;
          } else {
            self.list[indexes[i]].options = [];
            self.list[indexes[i]].originalOptions = [];
          }
        });
        self.selected.push([]);
        self.oldSelected.push("[]");
      });
    },
    updateDate(val) {
      if (typeof val.id != "undefined") {
        if (val.startDate && val.endDate) {
          this.dataChanged = true;
        }

        let sDate = val.startDate
          ? val.startDate
          : this.list[val.id].selected.startDate;
        let eDate = val.endDate
          ? val.endDate
          : this.list[val.id].selected.endDate;

        if (val.startDate) this.list[val.id].selected.startDate = val.startDate;
        if (val.endDate) this.list[val.id].selected.endDate = val.endDate;
        this.value.forEach((item, index) => {
          if (item.dateField) {
            this.$store.commit(`cache/${CACHE_INVALIDATE}`, item.store);
            this.$store
              .dispatch("cache/fetch", {
                key: item.store,
                dateData: {
                  dateField: item.dateField,
                  dateStart: sDate,
                  dateEnd: eDate,
                },
              })
              .catch((e) => e);
          }
        });
        this.$emit("input", this.list);
      }
    },
    clearFilters(noemit) {
      const tmp = [];
      this.list = this.value;
      for (let i = 0; i < this.list.length; i++) {
        tmp.push();
        if (this.list[i].type == "date") {
          if (this.list[i].default) {
            this.date.startDate = this.list[i].default.startDate;
            this.date.endDate = this.list[i].default.endDate;

            this.list[i].selected.startDate = this.list[i].default.startDate;
            this.list[i].selected.endDate = this.list[i].default.endDate;

            this.$refs[`date${i}`][0].applyValues(
              this.list[i].default.startDate.toDate(),
              this.list[i].default.endDate.toDate()
            );
          } else {
            this.date.startDate = moment().startOf("day");
            this.date.endDate = moment().endOf("day");

            this.list[i].selected.startDate = this.date.startDate;
            this.list[i].selected.endDate = this.date.endDate;

            this.$refs[`date${i}`][0].applyValues(
              this.date.startDate.toDate(),
              this.date.endDate.toDate()
            );
          }
        } else {
          this.list[i].selected = [];
        }
      }
      this.selected = tmp;
      this.dataChanged = false;
      if (!noemit) {
        this.$emit("click");
      }
    },
    setFilter(key, data) {
      this.clearFilters(true);
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].field == key) {
          this.$set(this.selected, i, data);
        }
      }
    },
    isEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
  },
  watch: {
    selected: {
      handler: function (newlist) {
        const oldSelected = this.oldSelected;

        const ls = JSON.parse(JSON.stringify(newlist));

        ls.forEach((selected, i) => {
          if (i >= this.selectedMax) return;

          if (JSON.stringify(selected) == oldSelected[i]) return;
          oldSelected[i] = JSON.stringify(selected);

          if (!selected) {
            this.list[i].selected = [];
            if (!this.list[i].filterOptions) return;
          }

          const tmp = [];
          if (selected) {
            const len = selected.length;

            if (!len) {
              if (typeof selected.value != "undefined") {
                this.list[i].selected = [selected.value];
              } else if (typeof selected.length === "undefined") {
                this.list[i].selected = [selected];
              } else {
                this.list[i].selected = [];
              }
              if (!this.list[i].filterOptions) return;
            }

            if (!len) {
              if (!this.isEmpty(selected)) {
                tmp.push(selected);
              }
            } else {
              selected.forEach((item) => {
                if (typeof this.list[i].trackBy !== "undefined") {
                  tmp.push(item);
                } else {
                  tmp.push(item.value);
                }
              });
            }
          }

          if (
            typeof this.list[i].type != "undefined" &&
            this.list[i].type == "date"
          ) {
            // noop
          } else {
            this.list[i].selected = tmp;
          }

          if (
            this.list[i].filterOptions &&
            this.list[i].filterOptions.length &&
            this.list[i].selected
          ) {
            const filterOptions = this.list[i].filterOptions;

            this.list.forEach((item, index) => {
              if (filterOptions.indexOf(item.field) > -1) {
                if (typeof item.filterOptionsBy == "function") {
                  item.filterOptionsBy(
                    this,
                    this.list[i].field,
                    this.list[i].selected
                  );
                }
              }
            });
          }
        });
        this.$emit("input", this.list);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
